import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_source_hdr_RowClass} from '../../../dbschema/bl_crm_contact_source_hdr.model';

export class ContactSourceContainerModel extends BaseContainerModel {
  bl_crm_contact_source_hdr: bl_crm_contact_source_hdr_RowClass = new bl_crm_contact_source_hdr_RowClass();
}
